import axios from "axios";
import config from "./config";

export const api = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true,
});

/**
 * Utility function for uploading files to the API
 * @param files Array of files to upload
 * @param endpoint API endpoint to send files to (defaults to /api/upload)
 * @returns Promise with the response data
 */
export const uploadFiles = async (
  files: File[],
  endpoint: string = "/api/upload"
) => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("files", file);
  });

  const response = await api.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
